import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, exhaustMap, map, of, switchMap, zip } from 'rxjs';
import { Store } from '@ngrx/store';

import { StoreApiService } from '@paymash/sdk/api/v2';
import { selectCompanyUuid } from '@public-page/store/company';
import { selectStoreUuid } from '@modules/company-page/store/company-stores';
import {
  BookingSelectServicesCategoriesApiActions,
  BookingSelectServicesCategoriesActions,
} from '@modules/booking/store/categories/categories.actions';

@Injectable()
export class CategoriesEffects {
  constructor(private actions$: Actions, private storeApiService: StoreApiService, private store: Store) {}

  loadCategories$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(BookingSelectServicesCategoriesActions.componentLoaded),
      switchMap(() =>
        zip(this.store.select(selectCompanyUuid), this.store.select(selectStoreUuid)).pipe(
          exhaustMap(([companyUuid, StoreUuid]) => {
            // use of(CATEGORIES) if you need mock
            return this.storeApiService.getCategories(companyUuid, StoreUuid);
          }),
          map((categories) => BookingSelectServicesCategoriesApiActions.loadCategoriesSuccess({ categories })),
          catchError(() => of(BookingSelectServicesCategoriesApiActions.loadCategoriesFailure))
        )
      )
    );
  });
}
